import '../css/app.css';
import '../css/vendor.css';
import '../css/ui-kit.css';
import '../css/main.css';
import '../css/index.css';
import '../css/content.css';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

window.addEventListener('DOMContentLoaded', () => {
	new Swiper('.section-product__swiper', {
		modules: [Navigation, Pagination],
		init: true,
		slidesPerView: 1,
		spaceBetween: 0,
		watchOverflow: true,
		observer: true,
		observeParents: true,
		pagination: {
			el: '.js-swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	new Swiper('.section-care__swiper', {
		modules: [Navigation, Pagination],
		init: true,
		slidesPerView: 1,
		spaceBetween:0,
		watchOverflow: true,
		observer: true,
		observeParents: true,
		pagination: {
			el: '.js-swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			1000: {
				slidesPerView: 1.5,
				spaceBetween: 24,
			}
		}
	});
});

